export default "__VITE_ASSET__mzgbsmiw__"